import React, { Dispatch, SetStateAction } from "react";
import { Form } from "react-bootstrap";
import { ELECTRICITY_AGREEMENT_SALE_VENDOR_MAP, ElectricityAgreementForm, ElectricityAgreementSaleVendor } from "../../models";
import Select from "react-select";

interface NewElectricityAgreementSaleFormProps {
    form: ElectricityAgreementForm;
    setForm: Dispatch<SetStateAction<ElectricityAgreementForm>>;
}

const SALE_VENDOR_OPTIONS = [
  { value: ElectricityAgreementSaleVendor.PARTNER, label: ELECTRICITY_AGREEMENT_SALE_VENDOR_MAP[ElectricityAgreementSaleVendor.PARTNER]},
  { value: ElectricityAgreementSaleVendor.FUEL, label: ELECTRICITY_AGREEMENT_SALE_VENDOR_MAP[ElectricityAgreementSaleVendor.FUEL]},
  { value: ElectricityAgreementSaleVendor.OTHER, label: ELECTRICITY_AGREEMENT_SALE_VENDOR_MAP[ElectricityAgreementSaleVendor.OTHER]},
]

export default function NewElectricityAgreementSaleForm(
    { form, setForm } : NewElectricityAgreementSaleFormProps
) {

  const currentSaleOriginOption = form.saleVendor ? { value: form.saleVendor, label: ELECTRICITY_AGREEMENT_SALE_VENDOR_MAP[form.saleVendor] } : null;

  return (
      <div>
          <div className="row">
              <div className="col-12 col-md-6">
                  <Form.Label>Müüja</Form.Label>
                      <Select
                          required
                          options={SALE_VENDOR_OPTIONS}
                          value={currentSaleOriginOption ?? null}
                          onChange={(opt: any) => {
                            if(opt?.value) {
                              setForm({
                                ...form,
                                saleVendor: opt.value
                              })
                            } else {
                              setForm({
                                ...form,
                                saleVendor: undefined,
                                saleNotes: undefined
                              })
                            }
                          }}
                          placeholder='Vali müüja'
                          className={'w-100 form-control form-select'}
                          isClearable
                      />
              </div>
              {
                form.saleVendor ? (
                  <div className="col-6">
                    <Form.Label>Muu</Form.Label>
                    <Form.Control
                        value={form?.saleNotes ?? ''}
                        onChange={(e: any) => setForm({
                            ...form, 
                            saleNotes : e.target.value
                        })}
                        maxLength={16}
                    />
                  </div>
                ) : null
              }
          </div>
      </div>
  );
}